// extracted by mini-css-extract-plugin
module.exports = {"container":"TechnicalError-module__container","helpContainer":"TechnicalError-module__helpContainer","btn":"TechnicalError-module__btn"};